/** Format integer cents as a localized currency string, e.g. 4397 -> "$43.97". */
export function formatMoney(cents: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(cents / 100);
  } catch {
    // Unknown currency code: fall back to a plain amount + code.
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}
